import { render, staticRenderFns } from "./OrganizationWrapper.vue?vue&type=template&id=7fa6d613&"
import script from "./OrganizationWrapper.vue?vue&type=script&lang=js&"
export * from "./OrganizationWrapper.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationWrapper.vue?vue&type=style&index=0&id=7fa6d613&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports